import React from 'react';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import ViewBlock from './Block/ViewBlock';

/* STYLE */
import '@redturtle/volto-rt-blocks/components/Blocks/Accordion/Accordion.less';

const View = ({ data, className }) => {
  return (
    <div className={cx('block accordion', className)}>
      <Container>
        <div className="content-wrapper">
          {data.title && <h2 className="headline">{data.title}</h2>}
          {data.description && (
            <div className="description">
              <TextBlockView data={{ value: data?.text ?? {} }} />
            </div>
          )}
          <div id="accordionGroup" className="accordion-wrapper">
            {data?.sections?.map((section, i) => (
              <ViewBlock data={section} index={i} key={i} />
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default View;
